import {optionSchema} from "@/common/schemas/option.schema";
import z from "zod";

export const tefProductCodeCreateSchema = z.object({
  product_id: optionSchema,
  code: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
});

export type TefProductCodeCreateValidationSchema = z.infer<typeof tefProductCodeCreateSchema>;

export const tefProductCodeUpdateSchema = z.object({
  code: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
});

export type TefProductCodeUpdateValidationSchema = z.infer<typeof tefProductCodeUpdateSchema>;
